"use strict";
exports.__esModule = true;
exports.SvgToolbarSheet = void 0;
var tslib_1 = require("tslib");
/**
 * This file is generated from 'npm run build-svg'. Any changes should be made to the
 * template in .svgrrc.js or to the source SVG in src/icons/svg.
 **/
var react_1 = tslib_1.__importDefault(require("react"));
exports.SvgToolbarSheet = function (props) { return (react_1["default"].createElement("svg", tslib_1.__assign({ viewBox: "0 0 20 20" }, props),
    react_1["default"].createElement("g", { fill: "none", fillRule: "evenodd" },
        react_1["default"].createElement("path", { fill: "currentColor", fillRule: "nonzero", d: "M15.525 2c.5 0 .912.377.968.862l.007.114v10.051a4.97 4.97 0 01-4.752 4.968l-.216.005H4.475a.975.975 0 01-.968-.862l-.007-.114V2.976c0-.5.376-.913.862-.97L4.475 2h11.05zm-.577 1.57H5.051v12.858h5.505l.001-3.688c0-.393.292-.718.67-.77l.106-.006 3.615-.002V3.571zm-.113 9.964h-2.727v2.768l.185-.053a3.827 3.827 0 002.488-2.518l.054-.197z" }),
        react_1["default"].createElement("path", { d: "M0 0h20v20H0z" })))); };
//# sourceMappingURL=ToolbarSheet.js.map